import moment from 'moment';

export function formatQuery(query) {
    const highlight = moment(query.daterange.highlight);
    const start = highlight.isValid() ? highlight : query.daterange.start;
    const end = highlight.isValid() ? highlight : query.daterange.end;
    const result = {
        start: formatDate(start),
        end: formatDate(end),
        step: calculateDaterangeStep(start, end),
    };
    if (query.country_id) {
        result.country_id = query.country_id;
    }
    return result;
}

/**
 * Formats a Moment.js date to be used as part of an api parameter.
 * @param {Moment} date The date to format
 * @returns {string} The string representation of the specified date.
 */
export function formatDate(date) {
    const m = moment(date);
    return m.format('YYYY-MM-DD');
}

/**
 * Calculates whether to group the data over the daterange by day or by month
 * @param {Moment} start Begin of the daterange
 * @param {Moment} end End of the daterange
 * @returns {string} Either 'day' or 'month' indicating the unit of the step
 */
export function calculateDaterangeStep(start, end) {
    start = moment(start);
    end = moment(end);
    if (!start.isValid() || !end.isValid()) {
        return 'day';
    }
    const delta = end.diff(start, 'days');
    const monthThreshold = 30 * 4;
    if (delta > monthThreshold) {
        return 'month';
    } else {
        return 'day';
    }
}



// WEBPACK FOOTER //
// ./src/api/format-query.js